import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b41c39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrapper" }
const _hoisted_2 = { class: "df mt-15" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "title-search" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_message_share_settings = _resolveComponent("app-message-share-settings")!
  const _component_item_file = _resolveComponent("item-file")!
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, {
      customTitle: "Select File",
      "count-padding": ""
    }, {
      bottom: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_search, {
              modelValue: _ctx.driveStore.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driveStore.search) = $event)),
              onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.search = ''))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["mrl-16 icon", _ctx.driveStore.isGridFolderView ? 'icon-tiles-2' : 'icon-list-view']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.driveStore.isGridFolderView = !_ctx.driveStore.isGridFolderView))
          }, null, 2)
        ])
      ]),
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["prevent"])),
          class: "back-link"
        }, " Cancel ")
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doneAction && _ctx.doneAction(...args)), ["prevent"])),
          class: _normalizeClass([{ disabled: !_ctx.selectedList.length }, "back-link"])
        }, " Done ", 2)
      ]),
      _: 1
    }),
    _createVNode(_component_app_message_share_settings, {
      "share-settings": _ctx.shareSettings,
      onUpdateSettings: _ctx.updateShareSettings
    }, null, 8, ["share-settings", "onUpdateSettings"]),
    _createElementVNode("div", {
      class: "scroll",
      onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      ref: "scroller"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["item-wrapper", { 'item-wrapper-grid': _ctx.driveStore.isGridFolderView }])
      }, [
        (!_ctx.dataLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.driveStore.files, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["item", { 'item-grid': _ctx.driveStore.isGridFolderView }]),
                key: file.id
              }, [
                _createVNode(_component_item_file, {
                  file: file,
                  onOnSelect: _ctx.selectFile,
                  "selected-id": _ctx.fileCheck[file.id] ? file.id : '',
                  selector: "",
                  columnView: !_ctx.driveStore.isGridFolderView,
                  "show-dots": false
                }, null, 8, ["file", "onOnSelect", "selected-id", "columnView"])
              ], 2))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.isPageLoading || _ctx.dataLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(21, (n) => {
              return _createElementVNode("div", {
                class: _normalizeClass(["item", { 'item-grid': _ctx.driveStore.isGridFolderView }]),
                key: n
              }, [
                _createVNode(_component_app_skeleton_media, {
                  "column-view": !_ctx.driveStore.isGridFolderView
                }, null, 8, ["column-view"])
              ], 2)
            }), 64))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.responseMessage), 1)
    ], 544)
  ]))
}